import React, { useRef, useEffect, useState } from "react";

export interface SegmentOption {
  value: string;
  label: string;
}

interface SegmentedControlProps {
  options: SegmentOption[];
  value: string;
  onChange: (value: string) => void;
}

export default function SegmentedControl({ options, value, onChange }: SegmentedControlProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [sliderStyle, setSliderStyle] = useState<React.CSSProperties>({});

  useEffect(() => {
    if (!containerRef.current) return;
    const buttons = containerRef.current.querySelectorAll<HTMLLabelElement>(".segmented-option");
    const activeIndex = options.findIndex((opt) => opt.value === value);
    if (buttons[activeIndex]) {
      const btn = buttons[activeIndex];
      setSliderStyle({
        width: btn.offsetWidth,
        left: btn.offsetLeft,
      });
    }
  }, [value, options]);

  return (
    <div
      ref={containerRef}
      className="relative flex items-center p-1 rounded-md bg-[rgb(var(--surface-2))] border border-[rgb(var(--border-primary))] h-[34px]"
    >
      {/* Sliding indicator */}
      <div
        className="absolute top-1 bottom-1 rounded shadow-sm transition-all duration-300 ease-in-out"
        style={{...sliderStyle, background: "var(--gold-grad)"}}
      />

      {options.map((opt) => (
        <label
          key={opt.value}
          className={`
            segmented-option relative z-[1] flex items-center px-3.5 h-full rounded cursor-pointer whitespace-nowrap
            text-[12px] font-medium transition-colors duration-200
            ${value === opt.value ? "text-white" : "text-[rgb(var(--text-secondary))] hover:text-[rgb(var(--text-primary))]"}
          `}
        >
          <input
            type="radio"
            name="segmented-control"
            value={opt.value}
            checked={value === opt.value}
            onChange={(e) => onChange(e.target.value)}
            className="sr-only"
          />
          {opt.label}
        </label>
      ))}
    </div>
  );
}
